import { useAuthStore } from 'src/stores'

const authStore = useAuthStore()

/**
 * @param {{ id: number | string; images: string[] | number[] }} { id, images }
 * @param {string} type
 * @param {number | string} index
 * @returns {string}
 */
export const generateImagePath = ({ id, images }, type, business_id, index = 0) => {
  return images?.length
    ? // FIXME
      `${authStore.loginData.assets_url}/${business_id}/${type}/${id}/${images[index]}.jpg`
    : ''
}

/**
 * @param {{ id: number | string; images: string[] | number[] }} { id, images }
 * @param {string} type
 * @param {number | string} index
 * @returns {string}
 */
export const getImagePath = ({ id, images }, type, business_id, index = 0) => {
  const imagePath = generateImagePath({ id, images }, type, business_id, index)
  return imagePath ? `${imagePath}?t=${Date.now()}` : ''
}

/**
 * @param {{id: string | number; images: number[]}} { id, images }
 * @param {string} type
 * @param {string} business_id
 * @returns {string[]}
 */
export const generateImageUrls = ({ id, images }, type, business_id) => {
  if (!images && !images.length) return []
  const imageUrls = []

  images.forEach((image) => {
    // FIXME
    imageUrls.push(`${authStore.loginData.assets_url}/${business_id}/${type}/${id}/${image}.jpg?t=${Date.now()}`)
  })

  return imageUrls
}

/**
 * @param {{id: string | number; video: number[]; images: number[]}} { id, video, images }
 * @param {string} type
 * @param {string} business_id
 * @returns {string[]}
 */
export const generateFileUrls = ({ id, images, video }, type, business_id, fileType = 'jpg') => {
  if (!video?.length && !images?.length) return []
  const fileUrl = []

  const files = video.length ? video : images
  files.forEach((file) => {
    fileUrl.push(`${authStore.loginData.assets_url}/${business_id}/${type}/${id}/${file}.${fileType}?t=${Date.now()}`)
  })

  return fileUrl
}
